class CocktailList {
  /**
   * @param {Node} container
   * @param {Object[]} cocktails
   * @param {Node} scrollBackEl
   */
  constructor(container, cocktails, scrollBackEl) {
    this.container = container
    this.cocktails = cocktails
    this.cocktailNodes = []
    this.scrollBackEl = scrollBackEl
    this.itemsContainer = this.container.querySelector('.cocktail-list__items')

    this.tasteThreshold = 15

    this.init()
  }

  init() {
    const moreBtn = this.container.querySelector('.cocktail-list__more')
    const backBtn = this.container.querySelector('.cocktail-list__back')

    this.container.addEventListener( 'filter', e => this.filter(e.detail) )

    moreBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.reset()
      this.container.scrollIntoView({ behavior: 'smooth' })
    })

    backBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.scrollBackEl?.parentElement.scrollIntoView({ behavior: 'smooth' })
    })

    this.cocktails.forEach(cocktail => {
      const box = this.createCocktailBox(cocktail)
      box.dataset.slug = cocktail.slug
      // this.cocktailNodes[cocktail.slug] = box
      this.cocktailNodes.push(box)
      this.itemsContainer.appendChild(box)
    })
  }

  createCocktailBox(cocktail) {
    const title = document.createElement('div')
    title.className = 'cocktail-box__title'
    title.innerText = cocktail.title

    // const debugInfo = document.createElement('div')
    // debugInfo.className = 'cocktail-box__debug'
    // debugInfo.innerText = JSON.stringify(cocktail.tastes)

    const image = document.createElement('div')
    image.className = 'cocktail-box__image'
    image.style.backgroundImage = `url(${cocktail.image})`

    const box = document.createElement('a')
    box.className = 'cocktail-box'
    box.appendChild(title)
    // box.appendChild(debugInfo)
    box.appendChild(image)
    box.href = cocktail.link

    if (cocktail.isNew) box.dataset.isNew = ''

    return box
  }

  filter(tastes) {
    // If all tastes are equal, reset filter and stop
    if (tastes.sweet === 33 && tastes.bitter === 33) {
      this.reset()
      return
    }

    const sorted = Object.entries(tastes).sort( (a, b) => b[1] - a[1] )
    const oppositeTaste = sorted.find(it => it[1] === 0)?.[0]

    const dominantTaste = sorted[0][0]

    const primaryMatches = []
    const secondaryMatches = []
    const tertiaryMatches = []
    const quaternaryMatches = []
    
    // Cocktails with dominant taste in first place
    let remainingCocktails = this.cocktails.filter(it => {
      if ( it.tastes[0] === dominantTaste ) {
        primaryMatches.push(it) 
        return false
      } else {
        return true
      }
    })
    primaryMatches.sort((a, b) => a.tastes.length - b.tastes.length )

    // Cocktails with dominant taste in second place
    remainingCocktails = remainingCocktails.filter(it => {
      if (
        it.tastes[1] === dominantTaste &&
        ( !oppositeTaste || !it.tastes.includes(oppositeTaste) ) // omit cocktails with opposite taste
      ) {
        secondaryMatches.push(it)
        return false
      } else {
        return true
      }
    })

    // Cocktails with dominant taste in third place
    remainingCocktails = remainingCocktails.filter(it => {
      if (
        it.tastes[2] === dominantTaste &&
        ( !oppositeTaste || !it.tastes.includes(oppositeTaste) ) // omit cocktails with opposit taste
      ) {
        tertiaryMatches.push(it)
        return false
      } else {
        return true
      }
    })

    // Cocktails with second dominant taste in first place
    remainingCocktails.forEach((it, i) => {
      if (
        it.tastes[2] === dominantTaste &&
        ( !oppositeTaste || !it.tastes.includes(oppositeTaste) ) // omit cocktails with opposit taste
      ) {
        quaternaryMatches.push(it)
      }
    })

    const result = [ ...primaryMatches, ...secondaryMatches, ...tertiaryMatches, ...quaternaryMatches ]

    this.cocktailNodes.forEach(it => {
      const order = result.findIndex(r => r.slug === it.dataset.slug)

      if (order > -1) {
        it.style.order = order
        it.classList.remove('hidden')
      } else {
        it.classList.add('hidden')
      }
    })

    // console.log(primaryMatches)
    // console.log(secondaryMatches)
    // console.log(tertiaryMatches)
    // console.log(quaternaryMatches)
    // console.log(remainingCocktails)
  }

  reset() {
    this.cocktailNodes.forEach(it => {
      it.style.order = null
      it.classList.remove('hidden')
    })
  }
}

if (COCKTAILS) {
  const cocktailLists = document.querySelectorAll('.cocktail-list')
  const tasteWheel = document.querySelector('.taste-wheel')

  for (const cocktailList of cocktailLists) {
    new CocktailList(cocktailList, COCKTAILS, tasteWheel)
  }
}
